import type { GithubAppStatus } from "./api.ts";

/** Fail-closed fallback when status fetch fails — never claim the App is configured. */
export const GITHUB_UNAVAILABLE_STATUS: GithubAppStatus = {
  configured: false,
  missing: [],
  install_url: null,
  note: "GitHub App status unavailable — optional sync is not required",
};

export type GithubSyncPhase = "unbound" | "configured";

/**
 * GitHub is optional sync/import. Never a loading gate: unbound until status
 * proves `configured: true`. `configured: false` is expected and must not block Setup.
 */
export function githubSyncPhase(status: GithubAppStatus | null): GithubSyncPhase {
  if (status?.configured === true) return "configured";
  return "unbound";
}

export function githubBindFormVisible(phase: GithubSyncPhase): boolean {
  return phase === "configured";
}
